
$( document ).ready(function() {

  /**
  	Sample it
  */
  
  var giftWrapNote = "";
  var giftWrapLine = 0;
  var giftWrap = {
    "variant" : 713151971347,
    "duster": 32662898376775,
    "selectedShippingOption" : "",
    "inCart" : false,
    "inCartOption" : 0,
    "note" : "",
    "line" : 0,
    "enabled" : true,
    "message" : "Add Gift Wrap",
    "image" : "https://cdn.shopify.com/s/files/1/0401/9849/products/GiftBox_88bd1e37-4edc-4a02-8112-8fbf0de99dc9_small.jpg?v=1657630986",
    "imageDuster" : "https://cdn.shopify.com/s/files/1/0401/9849/products/product-582621.jpg?v=1657698673"
  };

  function sampleIt() {

    var settings, removedPromo = false, totalCart = 0, totalSamples = 0, maxSamples = 3, sampleVariants = [], inCart = false, tabOpen = false, sampleTitles = [];

    settings = {
      sampleProductVariantId: 14473305284,
      addToSampleSelector: '.sample-it-button',
      variantSelector: '.product-variant-selectors',
      sampleTab: 'sample-tab',
      sampleSelector: 'sample-item',
      listSelector: 'sample-list',
      sampleRemove: 'sample-remove',
      sampleButton: 'add-samples'
    };

    var $div = $("<div>", {id: settings.listSelector, class: 'samples', ariaLive: 'polite'}).append('<div class="tab">Samples</div><div class="container"><div class="overview"></div><ol class="samples"></ol><div class="totals"></div><div class="terms"><p>Please note that samples are not valid for refunds and/or exchanges.</p></div></div>');

    $('body').append($div);

    function toggleTab() {
      if (tabOpen) {
        $div.animate({"margin-right": '-='+$div.width()});
      } else {
        $div.animate({"margin-right": '0px'});
      }
      tabOpen = !tabOpen;
    }

    showSamples = function(cart) {
      if ('detox-market-samples' in cart.attributes) {
        sampleTitles = [];
        sampleVariants = cart.attributes['detox-market-samples'].split(',');
        totalSamples = sampleVariants.length;
        $div.show().find('.samples, .overview').empty();
        $.each(sampleVariants,function(i,v) {
          var handle = v.split('#')[0], variant = v.split('#')[1];
          Shopify.getProduct(handle,function(product) {
            var sampleTitle = strip(product.vendor) + " - " + strip(product.title);
            if (product.variants.length > 1) {
              $.each(product.variants,function(j,va) { if (va.id == variant) { sampleTitle += " - " + va.title; } });
            }
            $div.find('.samples').append('<li data-sample="' + v + '" class="'+ settings.sampleSelector +'"><div class="sample-title">' + sampleTitle + '</div><div class="'+ settings.sampleRemove +'">remove</div></li>');
            sampleTitles.push(sampleTitle);
          });
        });

        if (totalSamples < maxSamples) {
          $div.find('.totals').html('<p>Please select another ' + (maxSamples - totalSamples) + ' sample' + ((maxSamples - totalSamples > 1) ? "s" : "") + ' to complete your order.</p>');
          if (inCart) { removeSamplesFromCart(); }
        } else {
          sampleFooter(false);
        }
      } else {
        if (inCart) { removeSamplesFromCart(); }
        $div.find('.samples, .overview').empty();
        $div.find('.overview').prepend("<p>We would love for you to try products before buying! The sample program is an easy way to try " + maxSamples + " products of your choice for only $7.99 + shipping.</p><ul><li>Click on ​'​sample it​'​ to add the sample to your cart</li><li>Repeat with ​" + (maxSamples - 1) + " other​ products</li><li>You are ready to go.</li></ul><p><a href='/pages/my-little-sample-bag'>See full details</a></p>");
        $div.find('.totals').html("<p>Please select " + maxSamples + " samples to complete your order.</p>");
      }
    }

    removeSamplesFromCart = function() {
      Shopify.removeItem(settings.sampleProductVariantId, function(cart) {
        inCart = false;
        totalCart --;
        updateDropdownCart(false);
        sampleFooter(false);
      });
    }
    
    showDropdownCart = function() {
      $div.hide();
      if (!$('body').hasClass('show-cart-summary')) {
        $('.toggle-cart-summary:first').click();
      }
    }
    
    updateDropdownCart = function(show) {
      var itemTemplate =
            `<div class="cart-summary-item" data-id="{id}" data-line="{line}">
                <div class="cart-summary-item__image">
                  <a href="{url}" class="cart-summary-item__link">
                    <div class="rimage-outer-wrapper">
                      <div class="rimage-wrapper" style="padding-top:100.0%">
                        <img class="rimage__image" src="{image}" alt="{title}">
                      </div>
                    </div>
                  </a>
                </div>
                <div class="cart-summary-item__detail">
                  <div class="cart-summary-item__title-variant">
                    <a class="cart-summary-item__title cart-summary-item__link" href="{url}">{title}</a>
                  </div>
                  <div class="cart-summary-item__price">
                    <span class="cart-summary-item__price-current theme-money">\${price}</span>
                  </div>
                  <div class="cart-summary-item__quantity">
                    <div class="qty-adjuster qty-adjuster--with-remove qty-adjuster--ajax" data-line-item-id="{id}" data-limit="7">
                      <div class="qty-adjuster__inner">
						
                        <button class="qty-adjuster__down" aria-label="Decrease">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                          </svg>
                        </button>
						
                        <input class="qty-adjuster__value" type="text" pattern="[0-9]*" name="updates[]" value="{quantity}" aria-label="Quantity">
						
                        <button class="qty-adjuster__up" aria-label="Increase">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus">
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                          </svg>
                        </button>
						
                      </div>
                      <a class="qty-adjuster__remove" href="/cart/change?line=1&amp;quantity=0">Remove</a>
                    </div>
                  </div>
                </div>
              </div>`;

        //$('.cart-summary .cart-summary-item-container').empty();

        $.ajax({
          type: "get",
          url: "/cart.js",
          dataType: "json",
          async: false,
          cache: false,
          success: function(cart) {
            totalCart = cart.item_count;
            //$('.navigation #count').html(totalCart);
            
            if (totalCart > 0) {

              var promoTotalSpend = 0, discountTotalSpend = 0, promoToRemove = 0, promoToAdd = {"variant":0,"minimumSpend":0}, discountToAdd = {"minimumSpend":0};

              $.each(cart.items, function(j, item) {

                var isPromoItem = false, isRemoveable = true;

                if (!(item.gift_card || item.product_type == "Subscription Box" || excludedTitles.indexOf(item.handle) > -1 || item.variant_id === settings.sampleProductVariantId) || item.compare_at_price > 0) {
                  promoTotalSpend += item.original_line_price;
                  if (!(excludedVendors.indexOf(item.vendor) > -1 || item.handle.indexOf("best-of-green-beauty-2019") > -1)) {
                    discountTotalSpend += item.original_line_price;
                  }
                }

                if (promoItems.length > 0) {
                  for (var j=0; j < promoItems.length; j++) {
                    if (promoItems[j].variant === item.variant_id) {
                      promoItems[j].inCart = true;
                      isRemoveable = promoItems[j].removeable;
                      isPromoItem = true;
                    }
                  }
                }

                var itemTitle = item.product_title.replace('Gift BFCM 2019 - ','');
                var itemDiv = itemTemplate.replace(/\{line\}/g, j+1).replace(/\{class\}/g, 'cart-promo-item').replace(/\{quantityplus\}/g, item.quantity+1).replace(/\{quantityminus\}/g, item.quantity-1).replace(/\{url\}/g, item.url).replace(/\{id\}/g, item.id).replace(/\{vendor\}/g, item.vendor).replace(/\{image\}/g, Shopify.resizeImage(item.image, "small")).replace(/\{quantity\}/g, item.quantity).replace(/\{price\}/g, item.line_price % 100 == 0 ? item.line_price/100 : Shopify.formatMoney(item.line_price,'{{amount}}')).replace(/\{title\}/g, itemTitle).replace(/\{variant\}/g, item.variant_title != null && item.variant_title != item.product_title ? item.variant_title : '');

                //$('.cart-summary .cart-summary-item-container').append(itemDiv);
                
                if (item.id == settings.sampleProductVariantId || item.id == giftWrap.variant || item.id == giftWrap.duster || isPromoItem) {
                  $('.cart-summary .cart-summary-item-container .cart-summary-item[data-id='+item.id+']').addClass('cart-promo-item');
                  $('.cart-summary .cart-summary-item-container .cart-summary-item[data-id='+item.id+']').find('.qty-adjuster__inner').empty();
                  $('.cart-summary .cart-summary-item-container .cart-summary-item[data-id='+item.id+']').find('.cart-summary-item__link').removeAttr("href").replaceWith(function(){ return $("<span>" + $(this).html() + "</span>"); });
                  if (isPromoItem) {
                    $('.cart-summary .cart-summary-item-container .cart-summary-item[data-id='+item.id+']').find('.qty-adjuster__inner').remove();
                    $('.cart-summary .cart-summary-item-container .cart-summary-item[data-id='+item.id+']').find('.cart-summary-item__price').remove();
                    //$('.cart-summary .cart-summary-item-container .cart-summary-item[data-id='+item.id+']').find('.shelf-cart--vendor').html('FREE GIFT');
                    if (!isRemoveable) {
                      $('.cart-summary .cart-summary-item-container .cart-summary-item[data-id='+item.id+']').find('.qty-adjuster__remove').remove();
                    }
                  }

                  if (item.id == giftWrap.variant || item.id == giftWrap.duster) {
                    giftWrap.inCart = true;
                    giftWrap.inCartOption = item.id;
                    giftWrap.line = j+1;
                  }
                }
              });

              if (discountsItems.length > 0) {
                for (var j=0; j < discountsItems.length; j++) {
                  if (discountTotalSpend >= discountsItems[j].minimumSpend && discountsItems[j].minimumSpend > discountToAdd.minimumSpend) {
                    discountToAdd = discountsItems[j];
                  }
                }
              }

              if (promoItems.length > 0) {
                for (var j=0; j < promoItems.length; j++) {
                  if (promoTotalSpend >= promoItems[j].minimumSpend && promoItems[j].minimumSpend > promoToAdd.minimumSpend) {
                    promoToAdd = promoItems[j];
                  }
                }
                for (var j=0; j < promoItems.length; j++) {

                  if (promoToAdd.variant != promoItems[j].variant && promoItems[j].inCart) {
                    promoItems[j].inCart = false;
                    promoToRemove = promoItems[j].variant;
                  }
                }
              }

              if (promoToRemove > 0 && promoItems.length > 0) {
                Shopify.removeItem(promoToRemove, function(cart) {
                  updateDropdownCart(true);
                  if($('#template-cart-footer').length) {
                    setTimeout(function(){ window.location.reload(true); }, 300);
                  }
                });
              } else if (promoToAdd.variant > 0 && promoItems.length > 0 && !promoToAdd.inCart && !removedPromo && promoToAdd.available) {
                addPromoToCart(promoToAdd);
                if($('#template-cart-footer').length) {
                  setTimeout(function(){ window.location.reload(true); }, 300);
                }
              } else {

                if (promoToAdd.variant > 0 && promoItems.length > 0 && !promoToAdd.available) {
                  $('.cart-summary .cart-form--checkout').prepend('<div class="p-2 mx-2 mb-2 text-uppercase border-primary align-center">'+promoToAdd.soldOutMessage+'</div>');
                }
                if (discountToAdd.minimumSpend > 0) {
                  $(window).on('load cc-cart-updated', () => {
                    if ($(".discountToAdd-spendMessage").length > 0) {
                      $('.discountToAdd-spendMessage').html(discountToAdd.spendMessage);
                    } else {
                      $('.cart-summary .cart-form--checkout').prepend('<div class="p-2 mx-2 mb-2 text-uppercase border-primary align-center discountToAdd-spendMessage">'+discountToAdd.spendMessage+'</div>');
                    }
                    if($('#template-cart-footer').length) {
                      $('#template-cart-footer').prepend('<input type="hidden" name="discount" value="'+discountToAdd.discount+'" />');
                    }
                    $('.cart-summary .cart-form--checkout .cart-summary__buttons button[name="checkout"]').attr("onclick","window.location='/checkout?discount="+discountToAdd.discount+"'");
                  });
                } else {
                  $('.cart-summary .cart-form--checkout .cart-summary__buttons button[name="checkout"]').attr("onclick","window.location='/checkout'");
                }

                if (discountTotalSpend != promoTotalSpend) {
                  $('.cart-summary .cart--discounts-warning').html('<div class="align-center mb-2"><i>One or more products in your order is excluded from discounts.<br /><a href="/pages/faqs">Please see our FAQs</a>.</i></div>');
                } else {
                  $('.cart-summary .cart--discounts-warning').empty();
                }

                $('.cart-summary .cart-footer__price').html(cart.items_subtotal_price % 100 == 0 ? cart.items_subtotal_price/100 : Shopify.formatMoney(cart.items_subtotal_price,'{{amount}}'));

                var free_shipping_spent_minimum = 7000;
                if (cart.items_subtotal_price < free_shipping_spent_minimum) {
                  $('.cart-summary .cart-footer__shipping-notice').removeClass('hidden');
                  $('.cart-summary .cart-footer__shipping-price').html(Shopify.formatMoney(free_shipping_spent_minimum - cart.items_subtotal_price,'${{amount}}'));
                } else if (cart.items_subtotal_price >= 30000) {
                  $('.cart-summary .cart-footer__shipping-signature').removeClass('hidden');
                } else {
                  $('.cart-summary .cart-footer__shipping-notice').addClass('hidden');
                  $('.cart-summary .cart-footer__shipping-signature').addClass('hidden');
                }
              
              	//$('.cart-summary .cart-footer').show();

                if (giftWrap.enabled) {
                  $('.cart-summary .cart-wrap').html('<div class="row border-top pt-3"><div class="column two-thirds"><label><input type="checkbox" class="mr-1" />'+ giftWrap.message + '</label><div class="select-hidden"><select class="p-1"><option value="'+ giftWrap.duster +'">Gift Bag ($0.99)</option><option value="'+ giftWrap.variant +'">Gift Box ($10)</option></select></div><div class="cart-gift-notice mt-1 select-hidden"><em>*Items will be in the bag/box, size permitting. One bag or box per order.</em></div></div><div class="column third"><img src="' + giftWrap.imageDuster + '" class="select-hidden" /></div></div><div class="row"><div class="column"><div class="cart-summary__notes select-hidden"><textarea id="cart-summary-note-temp" name="note_temp" rows="10" cols="50"></textarea><div class="cart-note-notice mt-1"><small><em>Be sure to include your name in the note. Unfortunately we cannot accommodate notes for international orders.</em></small></div></div></div></div>');
                  $("body").on("change",'.cart-summary .cart-wrap select',function() {
                    if($(this).val() == giftWrap.duster) {
                      $('.cart-summary .cart-wrap img').attr('src',giftWrap.imageDuster);
                    } else {
                      $('.cart-summary .cart-wrap img').attr('src',giftWrap.image);
                    }
                  });
                  if (giftWrap.inCart) {
                    $(".cart-summary .cart-wrap .select-hidden, .cart-footer .select-hidden").show();
                    if(giftWrap.inCartOption == giftWrap.duster) {
                      $('.cart-summary .cart-wrap img').attr('src',giftWrap.imageDuster);
                    } else {
                      $('.cart-summary .cart-wrap img').attr('src',giftWrap.image);
                    }
                    $('.cart-summary .cart-wrap select').val(giftWrap.inCartOption);
                    $('.cart-summary .cart-wrap input[type="checkbox"]').prop('checked', true);
                  } else {
                    $(".cart-summary .cart-wrap .select-hidden, .cart-summary .select-hidden").hide();
                  }
                }
              }

            } else {
              //$('.shelf-cart .cart-footer').hide();
              //$('.shelf-cart .shelf-cart-content').html('<div class="apercu-regular-15 text-center">It appears that your bag is currently empty!</div>');
            }

            if (show) {
              showDropdownCart();
            }
          }
        });
      }

    addPromoToCart = function(item) {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: "updates[" + item.variant + "]=1",
        dataType: 'text',
        success: function() {
          totalCart ++;
          updateDropdownCart(true);
        },
        error: function(t, r) {
          Shopify.onError(t, r)
        }
      });
    }

    addSamplesToCart = function(sampleTitles) {
      var itemdata = 'id=' + settings.sampleProductVariantId + '&quantity=1';
      $.each(sampleTitles,function(i,v) {
        itemdata += '&properties[Sample '+(i+1)+']='+encodeURIComponent(v);
      });
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: itemdata,
        dataType: 'json',
        success: function() {
          inCart = true;
          totalCart ++;
          sampleFooter(false);
          updateDropdownCart(true);
        },
        error: function(t, r) {
          Shopify.onError(t, r)
        }
      });
    }

    sampleFooter = function(warning) {
      $div.find('.totals').empty();
      if (!inCart) {
        $div.find('.totals').append('<button type="submit" class="btn btn-primary text-uppercase py-2 w-100" style="background-color : #5C6670 !important; border-color : #5C6670 !important;">Add samples to cart</button>');
      }
      $div.find('.totals').append('<p class="mt-1">You have selected all ' + maxSamples + ' samples. To change your selection, please remove a sample first.</p>');
    }

    init = function() {
      Shopify.getCart(function(cart) {
        if (cart.item_count > 0) {
          totalCart = cart.item_count;
          $.each(cart.items,function(i,v) { if (v.id == settings.sampleProductVariantId) { inCart = true; } });
        }
        showSamples(cart);
      });
    }

    init();
    setTimeout(updateDropdownCart(),100);

    $(window).on('cc-cart-updated', () => {
      $.ajax({
        type: "get",
        url: "/cart.js",
        dataType: "json",
        async: false,
        cache: false,
        success: function(cart) {
          if(cart.items_subtotal_price >= 30000) {
            $('.cart-summary .cart-footer__shipping-signature').removeClass('hidden');
          }
        }
      });
    });

    $div.on('click','.tab',function(e) {
      toggleTab();
    });
    $("#"+settings.listSelector).on('click','.btn-primary',function(e) {
      e.preventDefault();
      if (!inCart && sampleTitles.length == maxSamples) {
        addSamplesToCart(sampleTitles);
      }
      toggleTab();
    });

    $('body').on('click',settings.addToSampleSelector,function(e) {
      ga('send', 'event', {
        eventCategory: 'Sample It',
        eventAction: 'Viewed Sample',
        eventLabel: $(this).data('handle')
      });
      if ($(settings.addToCartSelector).hasClass('disabled')) {
        $('.BIS_trigger').trigger('click');
      } else {
        if (!tabOpen) { toggleTab(); }
        if (totalSamples < maxSamples) {

          var mySample = $(this).data('handle') + "#" + $(this).data('variant');

          if($.inArray(mySample,sampleVariants) !== -1) {
            alert('You have already selected this sample.');
          } else {

            sampleVariants.push(mySample);
            Shopify.updateCartAttributes({
              'detox-market-samples': sampleVariants
            }, function(cart) {
              showSamples(cart);
            });
          }
          $div.show();
        } else {
          sampleFooter(true);
          $div.find('.totals').addClass('sample-full');
          setTimeout(function(){ $div.find('.totals').removeClass('sample-full'); }, 2500);
        }
      }
    });

    $("#"+settings.listSelector).on('click','.'+settings.sampleRemove,function(e) {
      e.preventDefault();
      var mySample = $(this).parent().data('sample');
      sampleVariants = $.grep(sampleVariants, function(value) {
        return value != mySample;
      });
      Shopify.updateCartAttributes({
        'detox-market-samples': sampleVariants
      }, function(cart) {
        if (window.location.href.indexOf("/cart") !== -1) {
          location.reload();
        } else {
          if (!tabOpen) { toggleTab(); }
          showSamples(cart);
        }
      });
    });

    function strip(html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    }

    $('.product .form.give-gift').on('click','button',function(event) {
      event.preventDefault();

      var variant = $('.product .variants input[type="radio"]:checked').attr('id');
      var recipientEmail = "";
      var recipientName = "";
      var recipientMessage = "";
      var passed = true;
      if ($('#recipient-email').length) {
        recipientEmail = $('#recipient-email').val();
        recipientName = $('#recipient-name').val();
        recipientMessage = $('#recipient-message').val();

        if (recipientEmail == "" || recipientName == "") {
          alert("Please enter the recipient's name and email.");
          passed = false;
        }
      }
      if (passed) {
        doAddToCart(variant,1, "", recipientEmail, recipientName, recipientMessage);
      }
    });

    $("body").on("change",'.cart-wrap select',function() {
      if (giftWrap.inCart) {
        var toAdd = $(this).val();
        var toRemove = giftWrap.variant;
        if ($(this).val() == giftWrap.variant) {
          toRemove = giftWrap.duster;
        }

        $.post('/cart/update.js',"updates["+toRemove+"]=0", function(cartData) {
          giftWrap.inCartOption = toAdd;

          $.each($.parseJSON(cartData).items,function(i,v) {
            if (Object.keys(v.properties).length > 0) {
              $.each(v.properties,function(k,p) {
                if (k == "Shipping Option" && giftWrap.selectedShippingOption == '') {
                  giftWrap.selectedShippingOption = p;
                }
              });
            }
          });
          doAddToCart(toAdd,1,giftWrap.selectedShippingOption);
        });
      }
    });

    $("body").on("change",'.cart-wrap input[type="checkbox"]',function() {
      if($(this).is(':checked')) {
        $(".cart-wrap .select-hidden").show();
        if (!giftWrap.inCart) {
          var toAdd = $(".cart-wrap select").val();

          Shopify.getCart(function(cart) {
            if (cart.item_count > 0) {
              $.each(cart.items,function(i,v) {
                if (Object.keys(v.properties).length > 0) {
                  $.each(v.properties,function(k,p) {
                    if (k == "Shipping Option" && giftWrap.selectedShippingOption == '') {
                      giftWrap.selectedShippingOption = p;
                    }
                  });
                }
              });
            }
            giftWrap.inCart = true;
            doAddToCart(toAdd,1,giftWrap.selectedShippingOption);
          });
        }
      } else {
        $(".cart-wrap .select-hidden").hide();
        $.post('/cart/update.js',"note=&updates["+giftWrap.variant+"]=0&updates["+giftWrap.duster+"]=0", function() {
          giftWrap.inCart = false;
          //$(".shelf-cart-note").val('');
          updateDropdownCart(true);
        });
      }
    });

    $("body").on("input",'.cart-wrap #cart-summary-note-temp',function() {
      $("#cart-summary-note").val($(this).val());
    });

    function doAddToCart(id, qty, selectedShippingOption = "", recipientEmail = "", recipientName = "", recipientMessage = "") {
      var data = "";
      if (recipientEmail == "") {
        data = "quantity=" + qty + "&id=" + id + "&properties[Shipping Option]=" +selectedShippingOption;
      } else {
        data = "quantity=" + qty + "&id=" + id + "&properties[Shipping Option]=" +selectedShippingOption + "&properties[Recipient Email]=" +recipientEmail + "&properties[Recipient Name]=" +recipientName + "&properties[Recipient Message]=" +recipientMessage;
      }

      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        beforeSend: function() {
          // Pinterest tag
          // pintrk('track', 'addtocart');
        },
        success: function(i) {
          Shopify.getCart(function(cart) {
            totalCart += parseInt(qty,10);
            updateDropdownCart(true);
          });
        },
        error: function(i) {
          alert($.parseJSON(i.responseText).description);
        }
      });
    }
  };

  // New updates for Cart updates
  const open = window.XMLHttpRequest.prototype.open;

  function openReplacement() {
    this.addEventListener("load", function () {
      if (
        [
          "/cart/add.js",
          "/cart/update.js",
          "/cart/change.js",
          "/cart/clear.js",
        ].includes(this._url)
      ) {
        setTimeout(function(){updateDropdownCart()}, 1000);
      }
    });
    return open.apply(this, arguments);
  }
  
  window.XMLHttpRequest.prototype.open = openReplacement;
  // New updates for Cart updates - END

  
  sampleIt();


  // Banned Ingredients feature
  $('.ingredients dt').on('click','a',function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('open').next('dd').toggleClass('open');
  });

  $('.eight-ingredients').on('click','.all',function(e) {
    e.preventDefault();
    $('.ingredients dd').removeClass('open');
    $('.eight-ingredients dt').each(function() {
      $(this).removeClass('open').next('dd').removeClass('open');
    });
    $('.ingredients dt').removeClass('open').show();
  });

  $('.eight-ingredients').on('click keypress','dt',function(e) {
    //if (window.allyClick(e) === true) {
      $('.ingredients dt').removeClass('open').hide();
      $('.ingredients dd').removeClass('open');
      if ($(this).hasClass('open')) {
        $('.eight-ingredients dt').each(function() {
          $(this).removeClass('open').next('dd').removeClass('open');
        });
        $('.ingredients dt').show();
      } else {
        $('.eight-ingredients dt').each(function() {
          $(this).removeClass('open').next('dd').removeClass('open');
        });
        var ingredient = $(this).data('ingredient');
        $(this).addClass('open').next('dd').addClass('open');
        $('.ingredients dd .concerns li').each(function() {
          if ($(this).attr('class') == ingredient) {
            $(this).parent().parent().prev('dt').show();
          }
        });
      }
    //}
  });

  
  // Brands page
  showBrand = function(selector) {
    var $navItem = selector, $brands = $('.brand-letter-holder');
    $brands.show();
    if ($navItem.hasClass('active')) {
      $navItem.removeClass('active');
    } else {
      $('.brand-list--nav a').removeClass('active');
      $navItem.addClass('active');
      if ($navItem.data('brands') != "all") {
        $.each($brands, function(key, brand) {
          if ($(brand).data('letter') !== $navItem.text().toLowerCase()) {
            $(brand).hide();
          }
        });
      }
    }
  }

  var url = decodeURIComponent(window.location.href);
  var hashes = url.slice(window.location.href.indexOf('?') + 1).split('&');
  for(var i = 0; i < hashes.length; i++) {
    var hash = hashes[i].split('=');

    if (hash[0] == "loc") {
      if ($('.brand-list--nav a').length) {
        $('.brand-list--nav a').each(function(){
          if ($(this).text().toLowerCase() == hash[1].toLowerCase()) {
            showBrand($(this));
          }
        });

      } else {
        var scrollElement = $("a[name='"+ hash[1] +"']");
        $("html, body").scrollTop(scrollElement.offset().top);
      }
    }
  }

  $('.brand-list--nav a').click(function(e) {
    e.preventDefault();
    showBrand($(this));
  });
  
  
  // HGG 2020
  var sign = "", tagline = "";

  $("#stepa").on('click', 'button', function() {
    $("#stepa").addClass('d-none');
    $("#stepb").removeClass('d-none');
  });

  $("#stepb .sign").on('click', 'button', function() {
    $("#stepb").addClass('d-none');
    $("#stepc").removeClass('d-none');
    sign = $(this).data('sign');
    tagline = $(this).data('tagline');
    $("#stepc .sign-title").text(sign);
    $("#stepc .sign-tagline").text(tagline);

    $('.quiz-results .quiz-result').each(function () {
      if ( $(this).hasClass(sign.toLowerCase() ) ) {
        $(this).removeClass('d-none');
      }
    });
  });

  $("#stepc").on('click', '.quiz-retake', function() {
    $("#stepb").removeClass('d-none');
    $("#stepc").addClass('d-none');
    $('.quiz-results .quiz-result').addClass('d-none');
  });
  
  
  // HGG 2021
  $(".holiday-collections .image").mouseenter(function() {
    thisss = $(this);
    thisss.addClass('in-action');
    thisss.find('.video-on').addClass('open');
    thisss.find('.video-on').get(0).play();
    setTimeout(function(){
      thisss.removeClass('in-action');
    }, 1000);
  });

  $(".holiday-collections .image").mouseleave(function() {
    thiss = $(this);
    thiss.find('.video-on').removeClass('open');
    if (thiss.hasClass('in-action')) {
      thiss.find('.video-out').addClass('close');
      thiss.find('.video-out').get(0).play();
      thiss.find('.video-on').get(0).currentTime = 0;
      setTimeout(function(){
        thiss.find('.video-out').removeClass('close');
      }, 1000);
    } else {
      thiss.find('.video-out').addClass('close');
      thiss.find('.video-out').get(0).play();
      thiss.find('.video-on').get(0).currentTime = 0;
      setTimeout(function(){
        thiss.find('.video-out').removeClass('close');
      }, 1000);
    }
  });
  
  $(".holiday-wave").on('click', '.marquee__item_text', function (e) {
    var target_id = $(this).data('target');    
    var $template = $(target_id).html();        
    $.colorbox({
      closeButton: false,
      preloading: false,
      width:"90%",
      maxWidth:"1200px",
      open: true,
      speed: 200,
      html: [
        '<div class="action-icons">',
        '<a href="#" class="close-box action-icon" aria-label="', theme.strings.close, '">' + theme.icons.close + '</a>',
        '</div>', $template].
      join('')
    });
  });
  
  
  $(".holiday-wave").on('click', '#astrolgy_btn', function (e) {
    var $template = $("#astrolgy").html();        
    $.colorbox({
      closeButton: false,
      preloading: false,
      width:"90%",
      maxWidth:"1200px",
      open: true,
      speed: 200,
      html: [
        '<div class="action-icons">',
        '<a href="#" class="close-box action-icon" aria-label="', theme.strings.close, '">' + theme.icons.close + '</a>',
        '</div>', $template].
      join('')
    });
  });
                 
  
  // Hero Live Chat
  $(window).on('load', function() {
    setTimeout(function(){
      $('.hero-btn-circle').addClass('animate');
    }, 5000);
  });
  
  
  // Sustainability starts now
  if ($(".tree-number-value").length) {
  	$(window).scroll(treeScroll);
  }
  
  var viewed = false;
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  function treesCount() {
    let today = new Date();
    let nextDate = new Date("December 31, 2022");
    let msPerDay = 24*60*60*1000;
    let daysLeft = Math.round((nextDate.getTime() - today.getTime())/msPerDay);
    let trees = 411053 + (365 - daysLeft)*573;
    return trees > 620000 ? 620000 : trees;
  }

  function treeScroll() {
    if (isScrolledIntoView($(".tree-number")) && !viewed) {
      viewed = true;
      $('.progress-bar-fore').addClass('progress-filled').css('width', ((treesCount()/620000)*100) +'%');
      $('.tree-number-value').each(function () {
        $(this).prop('Counter',0).animate({
          Counter: treesCount()
        }, {
          duration: 1000,
          easing: 'swing',
          step: function (now) {
            $(this).text(Math.ceil(now).toLocaleString('en'));
          }
        });
      });
    }
  }
  
  
  // Show Inventory Stock
  $(".inventoryLocationInformation .showStoreStock").on("click keypress", function(e){
    $("#inventoryLocationInformation").toggleClass("closed")
  });


  // Tab handle
  if($('.tabs-menu div.tabs-menu-item').length > 0) {
    var tabSelector = $('.tabs-menu div.tabs-menu-item');
    
    tabSelector.bind('click', function() {
      $(this).parent().find('.tabs-menu-item').removeClass('active');
      $(this).addClass('active');
      
      tabId = $(this).attr('id');
      $(this).parent().parent().find('.tabs .tab').removeClass('current');
      $('.' + tabId).addClass('current');
    });
  }


  // Header Question Popup
  $("body").on("click", function(e){
    if( !$(e.target).hasClass('main_question__popup') && !$(e.target).hasClass('toolbar-question')) {
      $(".toolbar-question").removeClass("active");              
    }
  })
  
  $(".toolbar-question").on("click", function(e){
	$(this).toggleClass("active");
  })
  
  
  // Detox Subscription Box - Conflict modal
  $(".detox-box-subscription").on('click', '.detox-box__conflict_button', function (e) {
    var $template = $("#conflictModal").html();        
    $.colorbox({
      closeButton: false,
      preloading: false,
      width:"90%",
      maxWidth:"600px",
      open: true,
      speed: 200,
      html: [
        '<div class="action-icons">',
        '<a href="#" class="close-box action-icon" aria-label="', theme.strings.close, '">' + theme.icons.close + '</a>',
        '</div>', $template].
      join('')
    });
  });

  // Product Details - Conflict modal
  $(".product-details").on('click', '.detox-box__conflict_button', function (e) {
    e.preventDefault();
    var $template = $("#conflictModal").html();        
    $.colorbox({
      closeButton: false,
      preloading: false,
      width:"90%",
      maxWidth:"600px",
      open: true,
      speed: 200,
      html: [
        '<div class="action-icons">',
        '<a href="#" class="close-box action-icon" aria-label="', theme.strings.close, '">' + theme.icons.close + '</a>',
        '</div>', $template].
      join('')
    });
  });

});

// pdp multiple image functionality
if (document.querySelector('body').classList.contains('template-product')) {
  let multipleImageShow = document
    .querySelector('.container.product-container')
    .getAttribute('data-multipleimage');

  if (multipleImageShow == 'true') {
    console.log('5reach');
    setTimeout(function () {
      function imageHideAndShow(imageAltText, imageToShow, imageElement, addClass) {
        if (!imageAltText) {
          console.warn('imageAltText is undefined for an element:', imageElement);
          return;
        }

        let parts = imageAltText.split('|');
       
        let selectedImageText = parts[parts.length - 1].trim();
             console.log("selectedImageText", selectedImageText , imageToShow);
      console.log("imageElement",imageElement);
        if (
          selectedImageText.toUpperCase() == imageToShow.toUpperCase() ||
          selectedImageText.toUpperCase() == 'ALWAYS'
        ) {
        if (!imageElement.classList.contains(addClass)) {
            imageElement.classList.remove('hide-thumbanail-image');
            imageElement.classList.add(addClass);
        
            if (addClass === "slide-to-show") {
                imageElement.classList.add("no-more");
            }
        }
        } else {
          imageElement.classList.add('hide-thumbanail-image');
          imageElement.classList.remove(addClass);
        }
      }
     

      function mainImageSlider(slides) {
        $('.product-slideshow').slick({
          slide: slides,
          fade: false,
          speed: 500,
          arrows: true,
          dots: false,
          infinite: false,
          useTransform: true,
          adaptiveHeight: true,
          prevArrow: `<button type="button" class="slick-prev" aria-label="${theme.strings.previous}">${theme.icons.chevronLeft}</button>`,
          nextArrow: `<button type="button" class="slick-next" aria-label="${theme.strings.next}">${theme.icons.chevronRight}</button>`,
          cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
        });
      }

      function thumbnailSlider(sliderNames, slidesName) {
        $(sliderNames).slick({
          slide: slidesName,
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          speed: 400,
          prevArrow: `<button type="button" class="slick-prev" aria-label="${theme.strings.previous}">${theme.icons.chevronLeft}</button>`,
          nextArrow: `<button type="button" class="slick-next" aria-label="${theme.strings.next}">${theme.icons.chevronRight}</button>`,
          responsive: [
            {
              breakpoint: 1500,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 767,
              settings: {
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
          ],
        });
      }

      let activeSwatch = '';
      document.querySelectorAll('.selector-wrapper--swatch ul li').forEach(function (e) {
        e.addEventListener('click', function () {
          let imgShow = this.children[0].title;

          $('.product-slideshow').slick('unslick');
          this.closest('.product-container')
            .querySelectorAll('.product-slideshow .product-media')
            .forEach(function (mainImgElement) {
              let altText = mainImgElement.dataset.altMedia || '';
              imageHideAndShow(altText, imgShow, mainImgElement, 'slide-to-show_main');
            });

          setTimeout(function () {
            mainImageSlider('.slide-to-show_main');
          }, 50);

          $('.thumbnails').slick('unslick');
       
          
          document.querySelectorAll('.slide-to-show').forEach(el => el.classList.remove('slide-to-show'));
          let uniqueImages = new Set();

          this.closest('.product-container')
            .querySelectorAll('.thumbnails .thumbnail--media-image,.thumbnails .thumbnail--media-external_video,.thumbnails .thumbnail--media-video')
            .forEach(function (imgElement) {
              let imageElement = imgElement.querySelector('.rimage__image');
              if (imageElement && imageElement.alt) {
                let altText = imageElement.alt;
               
                if (!uniqueImages.has(altText)) {
                  uniqueImages.add(altText);
                   console.log("altTextnew",altText);
          
                  imageHideAndShow(altText, imgShow, imgElement, 'slide-to-show');
                }
              } else {
                console.warn('Missing or undefined alt attribute for a thumbnail:', imgElement);
              }
            });

          thumbnailSlider('.thumbnails', '.slide-to-show');
          $('.product-container .thumbnails').slick('slickGoTo', 0);
        });

        if (e.children[0].classList.contains('active')) {
          activeSwatch = e.children[0].title;
        }
      });

      if (activeSwatch !== '') {
        $('.product-slideshow').slick('unslick');
        document
          .querySelector('.product-container')
          .querySelectorAll('.product-slideshow .product-media')
          .forEach(function (loadMainImgElement) {
            let altText = loadMainImgElement.dataset.altMedia || '';
            imageHideAndShow(altText, activeSwatch, loadMainImgElement, 'main_slide-to-show');
          });

        mainImageSlider('.main_slide-to-show');

        $('.product-container .thumbnails').slick('unslick');

        // FIX: Clear old thumbnails
        document.querySelectorAll('.thumbnails .thumb_slide-to-show').forEach(el => el.classList.remove('thumb_slide-to-show'));

        let uniqueThumbs = new Set();
        document
          .querySelector('.product-container')
          .querySelectorAll('.thumbnails .thumbnail--media-image,.thumbnails .thumbnail--media-external_video,.thumbnails .thumbnail--media-video')
          .forEach(function (currentThumbnail) {
            let imageElement = currentThumbnail.querySelector('.rimage__image');
            if (imageElement && imageElement.alt) {
              let altText = imageElement.alt;
              if (!uniqueThumbs.has(altText)) {
                uniqueThumbs.add(altText);
                imageHideAndShow(altText, activeSwatch, currentThumbnail, 'thumb_slide-to-show');
              }
            } else {
              console.warn('Missing or undefined alt attribute for a thumbnail:', currentThumbnail);
            }
          });

        thumbnailSlider('.product-container .thumbnails', '.thumb_slide-to-show');
        $('.product-container .thumbnails').slick('slickGoTo', 0);
      }

      document.querySelector('.product-container').querySelector('.thumbnails').style.opacity = 1;
    }, 0);
  }
}
